import React from 'react';
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {InputSwitch} from 'primereact/inputswitch';

export default class ModalEditarWorkflowEmMassa extends React.Component {

    constructor(props) {
        super(props);
    }


    render(){
        return(
            <Dialog header="Editar Frequência Em Massa"
                    position="top"
                    visible={this.props.show}
                    style={{width: '50vw'}}
                    modal onHide={this.props.onHide}>
                <div className="container-fluid">

                        <React.Fragment>

                            <div className="form-group row">
                                <div className="col-12">
                                    <label htmlFor="frequencia">Frequência</label>
                                    <Dropdown
                                        style={{width: '100%'}}
                                        id="frequencia"
                                        value={this.props.batch_workflow_frequency}
                                        options={this.props.frequencias}
                                        onChange={(e) => this.props.handleChange("batch_workflow_frequency", e.value)}
                                        placeholder="Selecione a frequência"
                                        appendTo={document.body}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-12" style={{marginTop: '25px'}}>
                                    <button className="btn btn-sm btn-block btn-success"
                                            disabled={this.props.batch_workflow_frequency === null}
                                            onClick={this.props.handleSave}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </React.Fragment>
                </div>
            </Dialog>

        );
    }
}
